let url = "";
let urlOnboarding = "";

if (process.env.NODE_ENV === "development") {
    url = "http://localhost:8000";
    urlOnboarding = "http://localhost:3001";
} else {
    url = "https://api.masinegocios.com.br";
    urlOnboarding = "https://checkout.masinegocios.com.br";
}

export const Constants = {
    url: url,
    baseUrl: url + "/api/admin",
    urlOnboarding: urlOnboarding,
};
